module.exports = __webpack_public_path__ + "static/media/default-avatar-image.c94c7e46.png";